<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10MoWau/tc-custom/9781464207280.jpg?1730585564925" alt="This image is the cover for the book Proud Sinner, Medieval Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Proud Sinner, Medieval Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>2018 Lefty Award nominee for Best Historical Mystery Novel</b></p><p>In the winter of 1282, snow and ice ravage East Anglia while Prioress Eleanor awaits the decision of her young maid, Gracia, found starving on the streets some years ago, whether to take vows or to leave Tyndal Priory to make her way in the world.</p><p>But a far greater problem arrives at the priory gate. Seven abbots are riding to meet a papal legate in Norfolk. This is not a pilgrimage—each abbot hopes to make a case for being raised to a bishopric at the next vacancy. One abbot grows so ill the party has detoured to Tyndal. And despite the limited care Sister Anne can offer, Abbot Ilbert dies a horrible death, cause unknown. As his fellows prepare to resume their journey the next day, Abbot Tristram doubles over in great distress. By now the heavy snows have choked all the roads and the priory and village are marooned. Tristram dies. And then another abbot sickens while Sister Anne struggles to determine what killed these men—which question soon becomes not just what, but who did it?</p><p>One suspect is the gluttonous Odo, the ambitious Abbot of Caldwell and younger brother of Crowner Ralf. Since everyone despises Odo, is he simply a red herring? Prioress Eleanor is determined to stop the carnage that has shattered the tranquility in her priory while the Crowner must enforce the king's justice. Brother Thomas and Sister Anne form part of the investigation which plumbs the priory's kitchens and management as well as its medical facilities.</p><p><i>The Proud Sinner</i>, 13th in the Medieval Mysteries by Priscilla Royal, illustrates medieval matters medical and culinary as well as vocations for the religious life in a framework that crosses Chaucer's <i>Canterbury Tales</i> with Agatha Christie's <i>And Then There Were None</i>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Priscilla Royal
      </h2>
      
      <p class="authorDescription body article"><P>Priscilla Royal grew up in British Columbia and earned a B.A. in World Literature at San Francisco State University, where she discovered the beauty of medieval literature. She is a theater fan as well as a reader of history, mystery, and fiction of lesser violence. When not hiding in the thirteenth century, she lives in Northern California and is a member of California Writers Club, Mystery Writers of America, and Sisters in Crime.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e8b1dda